import { getDatasWithOption } from '../../utils/service';
import { BREAKPOINTS } from '../../model/model';
import { isChrome, isDefined, isObject, not, isNotDefined, each, truthy, falsy, parseInt10, isMobileResolution, getResolution } from '../../utils/util';
import SettingModel from './tpl';

class BeginnerMagic {
  constructor(options) {
    const _ = this;

    if (!options) return;
    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      classId: 0,
      level: 1,
      isLogin: false,
      global: window
    }, options);

    _.model = new SettingModel;
    _.global = (_.option.global) ? _.option.global : window;

  }

  init() {
    const _ = this;
    console.log('BeginnerMagic init !! ');

    _.setData();

  }

  setData() {
    const _ = this,
        _level = _.option.level,
        _classId = _.option.classId;

    getDatasWithOption([{
      type: 'GET',
      url: `${_.option.apiDomain}/api/returnbrave/recommend/magic/${_classId}`,
      dataType: 'json'
    }], (data) => {
      _.setInstance(data);
    }, (data) => {
      // no process

    });

  }

  setInstance(data){
    const _ = this,
        _level = _.option.level,
        _classId = _.option.classId,
        _wrap = _.option.wrap.magicWrap;

    let _dataBattle = data.magicRecommend.Battle,
        _dataHunt = data.magicRecommend.Hunt;


    if (!Object.keys) {
      Object.keys = function(obj) {
        var keys = [];

        for (var i in obj) {
          if (obj.hasOwnProperty(i)) {
            keys.push(i);
          }
        }
        return keys;
      };
    }

    if (!Object.values) {
      Object.values = function(obj) {
        var values = [];
        for (var i in obj) {
          if (obj.hasOwnProperty(i)) {
            values.push(obj[i]);
          }
        }
        return values;
      };
    }


    let magicTpl = '',
        magicBattleTpl = '',
        magicHuntTpl = '';

    let magicHuntDom  = $('<div class="magic-card  article-magic-hunt"><h3>사냥용</h3></div>');
    let magicBattleDom = $('<div class="magic-card article-magic-battle"><h3>전투용</h3></div>');

    // 입수법
    let acqTypes = Object.keys(_.model.ACQUISITION_NAMES);
    let magicAcquisitionDisplay = function(acquisition) {
      let acquisitionDom = $('<div class="acq"></div>');
      let acquisitionTpl = `<i class="acq-Quest">Q</i><i class="acq-NPC">N</i><i class="acq-Drop">D</i>`;
      acquisitionDom.append(acquisitionTpl);

        acquisition.map((acquisitionItem, acquisitionIdx) => {
          acquisitionDom.find(`.acq-${acquisitionItem}`).addClass('on');
        });
      return acquisitionDom.html();
    } // itemAcquisitionDisplay function()


    // magic Battle

    if(_dataBattle.required.length <= 0) {
      magicBattleTpl += ``;
    } else {
      magicBattleTpl += `<div class="article-magic-battle-required">
              <h4 class="battle-required">필수</h4><table><thead><tr><th>마법</th><th>습득 레벨</th><th>획득 방법</th><th>패시브</th></tr></thead><tbody>`;
      _dataBattle.required.map((item, index) => {
        magicBattleTpl += `<tr>
              <td class="magic-card__name"><a class="grade-${item.magicQuality}" href="${item.magicWikiUrl}">${item.magicName}</a></td>
              <td class="magic-card__level">${item.magicLevel}</td>
              <td class="magic-card__acquisition">${magicAcquisitionDisplay(item.acquisition)}</td>
              <td class="magic-card__passive">${item.magicPassive || `-`}</td>
          </tr>`;
      });
    }
    magicBattleTpl += `</tbody></table></div>`;


    if(_dataBattle.option.length <= 0) {
      magicBattleTpl += ``;
    } else {
      magicBattleTpl += `<div class="article-magic-battle-option">
              <h4 class="battle-option">선택</h4><table><thead><tr><th>마법</th><th>습득 레벨</th><th>획득 방법</th><th>패시브</th></tr></thead><tbody>`;
      _dataBattle.option.map((item, index) => {
        magicBattleTpl += `<tr>
              <td class="magic-card__name"><a class="grade-${item.magicQuality}" href="${item.magicWikiUrl}">${item.magicName}</a></td>
              <td class="magic-card__level">${item.magicLevel}</td>
              <td class="magic-card__acquisition">${magicAcquisitionDisplay(item.acquisition)}</td>
              <td class="magic-card__passive">${item.magicPassive || `-`}</td>
          </tr>`;
      });
      magicBattleTpl += `</tbody></table></div>`;
    }


    // magic Hunt

    if(_dataHunt.required.length <= 0) {
      magicHuntTpl += ``;
    } else {
      magicHuntTpl += `<div class="article-magic-hunt-required">
              <h4 class="hunt-required">필수</h4><table><thead><tr><th>마법</th><th>습득 레벨</th><th>획득 방법</th><th>패시브</th></tr></thead><tbody>`;
      _dataHunt.required.map((item, index) => {
        magicHuntTpl += `<tr>
              <td class="magic-card__name"><a class="grade-${item.magicQuality}" href="${item.magicWikiUrl}">${item.magicName}</a></td>
              <td class="magic-card__level">${item.magicLevel}</td>
              <td class="magic-card__acquisition">${magicAcquisitionDisplay(item.acquisition)}</td>
              <td class="magic-card__passive">${item.magicPassive || `-`}</td>
          </tr>`;
      });
      magicHuntTpl += `</tbody></table></div>`;
    }

    if(_dataHunt.option.length <= 0) {
      magicHuntTpl += ``;
    } else {
      magicHuntTpl += `<div class="article-magic-hunt-option">
              <h4 class="hunt-option">선택</h4><table><thead><tr><th>마법</th><th>습득 레벨</th><th>획득 방법</th><th>패시브</th></tr></thead><tbody>`;
      _dataHunt.option.map((item, index) => {
        magicHuntTpl += `<tr>
              <td class="magic-card__name"><a class="grade-${item.magicQuality}" href="${item.magicWikiUrl}">${item.magicName}</a></td>
              <td class="magic-card__level">${item.magicLevel}</td>
              <td class="magic-card__acquisition">${magicAcquisitionDisplay(item.acquisition)}</td>
              <td class="magic-card__passive">${item.magicPassive || `-`}</td>
          </tr>`;
      });
      magicHuntTpl += `</tbody></table></div>`;
    }

    magicHuntDom.append(magicHuntTpl);
    magicBattleDom.append(magicBattleTpl);

    $('.article-magic', _wrap).append( magicHuntDom.wrapAll('<div>').parent().html() , magicBattleDom.wrapAll('<div>').parent().html() );


  } // setInstance()

}

export default BeginnerMagic;


// WEBPACK FOOTER //
// ./_src/js/service/beginner/BeginnerMagic.js